var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "matching--category matching--category--no-y-padding" },
    [
      _c(
        "div",
        {
          staticClass:
            "matching--category-items matching--category-items-no-item-x-padding matching--category-items-center-bar"
        },
        _vm._l(_vm.matchingItems, function(item) {
          return _c("MatchingItem", {
            key: item.id,
            attrs: {
              label: item.label,
              score: item.score,
              "max-score": item.maxScore,
              clickable: _vm.clickable,
              "info-text": item.infoText,
              "with-percentage": _vm.withPercentage
            },
            on: {
              click: function($event) {
                return _vm.$emit("click")
              }
            }
          })
        }),
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }